export const actions = {
  CONFIGURACIONES_CASO3_BIS_LOAD_REQUESTED: 'CONFIGURACIONES_CASO3_BIS_LOAD_REQUESTED',
  CONFIGURACIONES_CASO3_BIS_LOAD_SUCCEEDED: 'CONFIGURACIONES_CASO3_BIS_LOAD_SUCCEEDED',
  CONFIGURACIONES_CASO3_BIS_LOAD_FILED: 'CONFIGURACIONES_CASO3_BIS_LOAD_FILED',

  CONFIGURACIONES_CASO3_LOAD_REQUESTED: 'CONFIGURACIONES_CASO3_LOAD_REQUESTED',
  CONFIGURACIONES_CASO3_LOAD_SUCCEEDED: 'CONFIGURACIONES_CASO3_LOAD_SUCCEEDED',
  CONFIGURACIONES_CASO3_LOAD_FILED: 'CONFIGURACIONES_CASO3_LOAD_FILED',

  CONFIGURACION_CASO3_INSERT_REQUESTED: 'CONFIGURACION_CASO3_INSERT_REQUESTED',
  CONFIGURACION_CASO3_INSERT_SUCCEEDED: 'CONFIGURACION_CASO3_INSERT_SUCCEEDED',
  CONFIGURACION_CASO3_INSERT_FILED: 'CONFIGURACION_CASO3_INSERT_FILED',

  CONFIGURACION_CASO3_UPDATE_REQUESTED: 'CONFIGURACION_CASO3_UPDATE_REQUESTED',
  CONFIGURACION_CASO3_UPDATE_SUCCEEDED: 'CONFIGURACION_CASO3_UPDATE_SUCCEEDED',
  CONFIGURACION_CASO3_UPDATE_FILED: 'CONFIGURACION_CASO3_UPDATE_FILED',

  CONFIGURACION_CASO3_BIS_INSERT_REQUESTED: 'CONFIGURACION_CASO3_BIS_INSERT_REQUESTED',
  CONFIGURACION_CASO3_BIS_INSERT_SUCCEEDED: 'CONFIGURACION_CASO3_BIS_INSERT_SUCCEEDED',
  CONFIGURACION_CASO3_BIS_INSERT_FILED: 'CONFIGURACION_CASO3_BIS_INSERT_FILED',

  CONFIGURACION_CASO3_BIS_UPDATE_REQUESTED: 'CONFIGURACION_CASO3_BIS_UPDATE_REQUESTED',
  CONFIGURACION_CASO3_BIS_UPDATE_SUCCEEDED: 'CONFIGURACION_CASO3_BIS_UPDATE_SUCCEEDED',
  CONFIGURACION_CASO3_BIS_UPDATE_FILED: 'CONFIGURACION_CASO3_BIS_UPDATE_FILED',

  CONFIGURACION_CASO3_BIS_DELETE_REQUESTED: 'CONFIGURACION_CASO3_BIS_DELETE_REQUESTED',
  CONFIGURACION_CASO3_BIS_DELETE_SUCCEEDED: 'CONFIGURACION_CASO3_BIS_DELETE_SUCCEEDED',
  CONFIGURACION_CASO3_BIS_DELETE_FILED: 'CONFIGURACION_CASO3_BIS_DELETE_FILED',
}

export const getConfiguracionesCaso3BisAction = dispatch => {
  dispatch({
    type: actions.CONFIGURACIONES_CASO3_BIS_LOAD_REQUESTED,
  })
}

export const getConfiguracionesCaso3Action = dispatch => {
  dispatch({
    type: actions.CONFIGURACIONES_CASO3_LOAD_REQUESTED,
  })
}

export const onSubmitConfiguracionCaso3FormAction = (dispatch, formConfiguracionCaso3) => {
  dispatch({
    type: actions.CONFIGURACION_CASO3_INSERT_REQUESTED,
    payload: formConfiguracionCaso3,
  })
}

export const onSubmitUpdateConfiguracionCaso3FormAction = (dispatch, formConfiguracionCaso3) => {
  dispatch({
    type: actions.CONFIGURACION_CASO3_UPDATE_REQUESTED,
    payload: formConfiguracionCaso3,
  })
}

export const onSubmitConfiguracionCaso3BisFormAction = (dispatch, formConfiguracionCaso3Bis) => {
  dispatch({
    type: actions.CONFIGURACION_CASO3_BIS_INSERT_REQUESTED,
    payload: formConfiguracionCaso3Bis,
  })
}

export const onSubmitUpdateConfiguracionCaso3BisFormAction = (
  dispatch,
  formConfiguracionCaso3Bis,
) => {
  dispatch({
    type: actions.CONFIGURACION_CASO3_BIS_UPDATE_REQUESTED,
    payload: formConfiguracionCaso3Bis,
  })
}

export const deleteConfiguracionCaso3BisAction = (dispatch, id) => {
  dispatch({
    type: actions.CONFIGURACION_CASO3_BIS_DELETE_REQUESTED,
    payload: id,
  })
}
